import { NewBannerType } from "types/Banners";
import { api } from "utils/hostname";
import url from "url/index";

export const fetchBanners = async (): Promise<NewBannerType[]> => {
  try {
    const response = await api(true, true).get<NewBannerType[]>(
      url.config.api.banners.root,
      {
        headers: {
          "f-v": import.meta.env.VITE_APP_VERSION_APP,
        },
      },
    );
    return response.data;
  } catch (error) {
    throw new Error("Failed to fetch banners");
  }
};
